import { Gender } from './Gender'
import Image from './Image'

import { ImageProps } from '@src/quince-components/src'

interface IProductImageOption {
  readonly name: string
  readonly values: string[]
}

export class ProductImageOption implements IProductImageOption {
  readonly name: string
  readonly values: string[]

  constructor({ name, values }: IProductImageOption) {
    this.name = name
    this.values = values
    return {
      ...this,
    }
  }
}

interface IProductImage {
  readonly image: Image
  readonly options: ProductImageOption[]
  readonly gender?: Gender | undefined | null
  readonly isDynamicImagePreview?: boolean
}

export default class ProductImage implements IProductImage {
  readonly image: Image
  // This tells for what all options this image is applicable
  readonly options: ProductImageOption[]
  readonly gender: Gender | undefined | null
  readonly isDynamicImagePreview?: boolean

  constructor({ image, options, gender = undefined, isDynamicImagePreview = false }: IProductImage) {
    this.image = image
    this.options = options
    this.gender = gender
    this.isDynamicImagePreview = isDynamicImagePreview
    return {
      ...this,
    }
  }

  static makeImageProps(productImage?: ProductImage): ImageProps {
    if (productImage === undefined) {
      return {
        url: '',
        title: '',
        height: 100,
        width: 100,
        alt: '',
      }
    }
    return Image.makeImageProps(productImage.image)
  }
}
